<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="welcome-title">
          {{ $t("common.hi") }}, <span>{{ user.name }}</span>
        </div>
      </div>
    </div>

    <div class="dashboard-content mt-4">
      <policy-detail />

      <div class="container-fluid2">
        <div class="row">
          <div class="col-12 col-lg-3 mb-3">
            <announcement-column />
          </div>

          <div class="col-12 col-lg-3 mb-3">
            <workspace-column />
          </div>

          <div class="col-12 col-lg-3 mb-3">
            <task-column />
          </div>

          <div class="col-12 col-lg-3 mb-3">
            <question-set-column />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationList from "@/modules/organization/organization-view";
import MenuItem from "@c/menu-item.vue";
import AnnouncementColumn from "./components/announcement-column";

import NotifyCard from "./components/notify-card.vue";
import QuestionSetColumn from "./components/question-set-column";
import TaskColumn from "./components/task-column";
import WorkspaceColumn from "./components/workspace-column";

import policyDetail from "../../policy/component/policy-detail";

export default {
  components: { OrganizationList, MenuItem, NotifyCard, AnnouncementColumn, WorkspaceColumn, TaskColumn, TaskColumn, QuestionSetColumn, policyDetail },
  data() {
    return {
      rows: 100,
      perPage: 2,
      currentPage: 1,
      taskList: [
        {
          name: "Envanter Veri Girişi",
          logo: "phexum-logo.png",
          companyName: "Phexum Software",
          date: { day: "Bugun", date: "06/07/2023", hour: "13:58" },
        },
        {
          name: "Envanter Veri Girişi",
          logo: "phexum-logo.png",
          companyName: "Phexum Software",
          date: { day: "Bugun", date: "06/07/2023", hour: "13:58" },
        },
      ],
      questionList: [
        {
          name: "Insan Kaynaklari Sorulari",
          logo: "phexum-logo.png",
        },
      ],
    };
  },
  computed: {
    userLetterAvatar() {
      const arr = this.user.name?.split(" ");
      const avatar = [];
      for (const [i, value] of arr.entries()) {
        avatar.push(value.charAt(0));
        if (i == 1) {
          break;
        }
      }
      return avatar.join("");
    },
    user() {
      return this.$store.getters["user/account"];
    },
    selectedOrganization() {
      return this.$store.getters["organization/selected"];
    },
    announcementPagination() {
      return this.$store.getters[`announcement/pagination`];
    },
  },
  mounted() {},
  methods: {
    paginateAnnouncement() {
      this.$store.dispatch(`${state}/paginate`, this.request);
      this.selectedItems = [];
    },
  },
};
</script>
